import { useRef } from 'react';
import * as S from './ResponseEditModal.styles';

import { useOnClickOutside } from '@/common/service/hooks';
import { ReplyProps } from './ResponseEditModal.types';
import { Button } from '@/common/ui';

const ResponseEditModal = ({ show, setShow, edit }: ReplyProps) => {
    const ref = useRef<HTMLDivElement>(null);
    useOnClickOutside(ref, () => closeModal());

    if (!show) {
        return null;
    }

    const closeModal = () => {
        setShow(false);
    };

    return (
        <>
            {show && (
                <S.ModalWrapper>
                    <S.ModalContent ref={ref}>
                        <S.CloseButton onClick={() => closeModal()}>
                            <S.CloseButtonWithIcon />
                        </S.CloseButton>
                        <S.InfoMessage>
                            <S.RedirectIcon />
                            <S.YouRedirected>
                                You will be redirected to the booking page
                            </S.YouRedirected>
                            <S.Buttons>
                                <S.BtnCancelWrapper>
                                    <Button variant="secondary" onClick={closeModal}>
                                        Cancel
                                    </Button>
                                </S.BtnCancelWrapper>
                                <S.BtnOkWrapper>
                                    <Button variant="primary" onClick={edit}>
                                        Ok
                                    </Button>
                                </S.BtnOkWrapper>
                            </S.Buttons>
                        </S.InfoMessage>
                    </S.ModalContent>
                </S.ModalWrapper>
            )}
        </>
    );
};

export { ResponseEditModal };
